import { icons } from 'assets/icons'
import React, { useState } from 'react'
import {
  ACCOUNT_TYPE,
  useAccountsCreation,
} from 'common/hooks/useAccountsCreation'
import { BsInfoCircleFill } from 'react-icons/bs'
import { AccountsCreationModal } from './components/more-info-modal'
import { AccountsLayout } from './components/layout'

const ProfileCreation = () => {
  const [openModal, setOpenModal] = useState<boolean>(false)
  const { selectedType, onSelectedType, onSelectedTypeAction } =
    useAccountsCreation()

  const handleAccountType = (type: string) => {
    onSelectedType(type)
  }

  const onOpenModal = () => {
    openModal ? setOpenModal(false) : setOpenModal(true)
  }

  const handleSubmit = () => {
    onSelectedTypeAction()
  }

  return (
    <>
      <AccountsLayout>
        <div className='flex relative md:w-[900px] !m-auto md:p-[60px] bg-white rounded-[20px] shadow-[-0.8px_-0.8px_16px_0px_rgba(0,0,0,0.25)]'>
          <div className='md:p-[30px] !m-auto'>
            <h1 className='text-[#182D59] md:text-[32px] font-bold md:mb-[50px]'>
              Account Selection
            </h1>
            <p className='text-[#182D59] text-[24px] font-medium md:mb-[44px]'>
              Select account type
            </p>
            <div className='flex md:gap-[50px] md:mb-[26px]'>
              {ACCOUNT_TYPE.map((type) => (
                <div
                  className='cursor-pointer'
                  onClick={() => handleAccountType(type)}
                >
                  <div className='bg-[#001A3D] w-[64px] h-[64px] p-[16px] rounded-[8px] shadow-[0px_1px_4px_0px_rgba(0,0,0,0.25)] hover:bg-gradient-to-r from-inherit to-[#26456F] to-100%'>
                    <img src={icons[type.replace(' ', '_')]} alt='' />
                  </div>
                  <p className='md:mt-[12px] text-[16px] font-medium'>{type}</p>
                </div>
              ))}
            </div>
            <div className='flex justify-end md:mb-[70px]'>
              <p
                className='text-[#001A3D] text-[12px] flex items-center gap-[5px] cursor-pointer '
                onClick={onOpenModal}
              >
                <BsInfoCircleFill color='#8DD8EB' className='' /> Which account
                should I choose?
              </p>
            </div>
            <div className='flex justify-end'>
              <button
                onClick={() => handleSubmit()}
                className={`btn ${
                  selectedType
                    ? 'btn-primary'
                    : 'btn-default bg-[#F4F4F4] text-[#A0ABBE]'
                }`}
              >
                Continue
              </button>
            </div>
          </div>
          <AccountsCreationModal open={openModal} setModal={setOpenModal} />
        </div>
      </AccountsLayout>
    </>
  )
}

export default ProfileCreation
